'use client';

import crypto from 'crypto';
import dynamic from 'next/dynamic';
import { ReactNode, useState, Children, cloneElement } from 'react';

import { cn } from '@natu/utils/cn';

const Button = dynamic(() => import('@natu/ui/Button').then(mod => mod.Button));

export interface CaseStudiesGridContentProps {
  showLoadMoreButton: boolean;
  totalItems: number;
  children: ReactNode;
  className: string;
}

export const CaseStudiesGridContent = ({
  showLoadMoreButton,
  totalItems,
  children,
  className,
}: CaseStudiesGridContentProps) => {
  const [splitCount, setSplitCount] = useState(4);

  const handleSplitCountIncrease = () => {
    setSplitCount(prev => Math.min(prev + 4, totalItems));
  };

  const visibleItems = Children.toArray(children).slice(0, splitCount);
  const firstColumnItems = visibleItems.filter((_, index) => index % 2 === 0);
  const secondColumnItems = visibleItems.filter((_, index) => index % 2 !== 0);

  return (
    <div className={cn(className, 'flex flex-col gap-y-9 lg:gap-y-20')}>
      <div className="flex flex-col gap-y-9 lg:grid lg:grid-cols-2 lg:gap-x-16">
        <ul className="flex flex-col gap-y-9 lg:gap-y-12">
          {firstColumnItems.map(child => (
            <li key={crypto.randomBytes(20).toString('hex')}>
              {cloneElement(child as React.ReactElement)}
            </li>
          ))}
        </ul>
        <ul className="flex flex-col gap-y-9 lg:mt-28 lg:gap-y-12">
          {secondColumnItems.map(child => (
            <li key={crypto.randomBytes(20).toString('hex')}>
              {cloneElement(child as React.ReactElement)}
            </li>
          ))}
        </ul>
      </div>

      {showLoadMoreButton && splitCount < totalItems && (
        <Button
          onClick={handleSplitCountIncrease}
          size="xl"
          variant="outline-transparent"
          className="relative z-10 mx-auto w-fit uppercase"
        >
          Load more cases
        </Button>
      )}
    </div>
  );
};
